<template>
  <div class="main">
    <heads></heads>
    <navs></navs>
    <banners></banners>
    <div class="content">
      <gerenzhongxinnav />
      <div class="gezx-nr">
        <div class="gezx-nr-title"><span>个人信息</span></div>
        <div class="gezx-nr-con">
          <div class="gezx-nr-cons">
            <div class="gezx-nr-cons-nr">
              <span class="gezx-nr-cons-nr-title">用户名：</span
              >{{ userinfoinxi.username }}
            </div>
            <div class="gezx-nr-cons-cz"></div>
          </div>
          <div class="gezx-nr-cons">
            <div class="gezx-nr-cons-nr">
              <span class="gezx-nr-cons-nr-title">真实姓名：</span
              >{{ userinfoinxi.realname }}
            </div>
          </div>
          <div class="gezx-nr-cons">
            <div class="gezx-nr-cons-nr">
              <span class="gezx-nr-cons-nr-title">联系方式：</span
              >{{ userinfoinxi.usertel }}
            </div>
          </div>
          <div class="gezx-nr-cons">
            <div class="gezx-nr-cons-nr">
              <span class="gezx-nr-cons-nr-title">联系邮箱：</span
              >{{ userinfoinxi.cemail }}
            </div>
          </div>
          <div class="gezx-nr-cons">
            <div class="gezx-nr-cons-nr">
              <span class="gezx-nr-cons-nr-title">联系地址：</span
              >{{ userinfoinxi.caddress }}
            </div>
          </div>
        </div>
        <div class="gezx-nr-cz">
          <el-button type="primary" @click="dialogTableVisible = true"
            >修改个人信息</el-button
          >
          <el-button type="warning" @click="dialogTableVisiblepsw = true"
            >修改密码</el-button
          >
        </div>
      </div>
    </div>

    <footers></footers>

    <!-- 修改资料弹窗 -->
    <el-dialog v-model="dialogTableVisible" title="修改个人信息" width="800">
      <el-form>
        <el-form-item label="真实姓名">
          <el-input v-model="userinfo.realname" placeholder="请输入真实姓名"/>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="userinfo.usertel" placeholder="请输入联系方式" />
        </el-form-item>
        <el-form-item label="联系邮箱">
          <el-input v-model="userinfo.cemail" placeholder="请输入联系邮箱" />
        </el-form-item>
        <el-form-item label="联系地址">
          <el-input v-model="userinfo.caddress" placeholder="请输入联系地址" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="dialogTableVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog v-model="dialogTableVisiblepsw" title="修改密码" width="800">
      <el-form>
        <el-form-item label="旧密码">
          <el-input v-model="psw.oldpsw" type="password" placeholder="请输入当前密码"/>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input
            type="password"
                v-model="psw.newpsw"
                show-password
                placeholder="请设置新密码"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitpsw">保存</el-button>
          <el-button @click="dialogTableVisiblepsw = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script setup>
import { post, get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { User, Medal } from "@element-plus/icons-vue";
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

let dialogTableVisible = ref(false);
let dialogTableVisiblepsw = ref(false)
let psw=reactive({
  oldpsw:'',
  newpsw:'',
})
let userinfo = reactive({
  realname: "",
  usertel: "",
  cemail: "",
  caddress: "",
});
let userinfoinxi = reactive({});
// 获取用户信息
const getuserinfo = () => {
  get("/api/User/GetTheUserInfo").then((result) => {
    Object.assign(userinfoinxi, result.data);
    Object.assign(userinfo, result.data);
  });
};
getuserinfo();

// 修改个人信息
const onSubmit = () => {
  post("/api/User/UpdateUserInfo", userinfo).then((res) => {
    ElMessage({
      message: "保存成功！",
      duration: 1000,
      onClose: () => {
        getuserinfo();
        dialogTableVisible.value = false;
      },
    });
  });
};
// 修改密码
const onSubmitpsw = () => {
  post("/api/User/UpdateUserPass", {
    oldpass:psw.oldpsw,
    newpass:psw.newpsw,
    surepass:psw.newpsw,
  }).then((res) => {
    ElMessage({
      message: "修改成功！",
      duration: 1000,
      onClose: () => {
        dialogTableVisiblepsw.value = false;
      },
    });
  });
};



</script>

<style scoped>
.main {
  background: #f5fcff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
  padding: 30px 0;
}
.content::after {
  content: "";
  display: table;
  clear: both;
}

.gezx-nr {
  float: right;
  width: 900px;
  height: auto;
  min-height: 490px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.gezx-nr-title {
  position: relative;
  padding: 20px 0 0 0;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
}
.gezx-nr-title > span {
  position: absolute;
  left: 10px;
  top: 8px;
  display: block;
  width: 80px;
  height: 30px;
  text-align: center;
  background: #fff;
}
.gezx-nr-con {
  margin-top: 30px;
  margin-bottom: 30px;
}
.gezx-nr-cons {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gezx-nr-cons-nr {
  width: 600px;
}
.gezx-nr-cons-nr-title {
  display: inline-block;
  width: 100px;
}
</style>
